import { useContext } from 'react';
import LoadingPlaceholder, { LoaderType } from 'shared/components/loading-placeholder';
import { RolePlayInteractionMode } from 'redux/schemas/models/ai-role-play';
import AiConversationContext from './context';

const OpeningNarrative = () => {
  const {
    openingNarrative,
    interactionMode,
  } = useContext(AiConversationContext);
  if (openingNarrative) {
    return (
      <div className='w-100 mt-5'>
        {openingNarrative}
      </div>
    );
  }
  if (interactionMode === RolePlayInteractionMode.VOICE) {
    return null;
  }
  return (
    <LoadingPlaceholder
      loaderType={LoaderType.HALF}
      className='mt-5'
    />
  );
};

export default OpeningNarrative;
